import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { ListSystemsResponse } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { GlobalPermission } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/user_pb';
import { requireUserGlobalPermission } from '~/shared/auth/auth-utils';
import { listUsersQuery } from '~/pages/Users/api/users.queries';
import { UsersModel } from '~/pages/Users/models/UsersModel';
import { listSystemsQuery } from '~/shared/api/system.queries';

export type UsersLoaderData = {
  users: UsersModel;
  systems: ListSystemsResponse;
};

export const usersLoader =
  (queryClient: QueryClient) =>
  async ({
    request,
  }: LoaderFunctionArgs): Promise<UsersLoaderData | Response> => {
    await requireUserGlobalPermission(
      queryClient,
      request,
      GlobalPermission.USER_ADMIN,
    );

    const listSystemsResponsePromise =
      queryClient.ensureQueryData(listSystemsQuery);

    const usersPromise = queryClient.ensureQueryData(listUsersQuery());

    const [users, systems] = await Promise.all([
      usersPromise,
      listSystemsResponsePromise,
    ]);
    return { users, systems };
  };
